const initial_state = {
  my_company_list: [],
  competitor_list: [],
  all_customer_list: [],
  cannib_polygon_list: [],
  white_space_polygon_list: [],
  my_iso: [],
  competitor_iso: [],
};

export default function gap_reducer(state = initial_state, action) {
  switch (action.type) {
    case "set_value_gap":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    default:
      return state;
  }
}
